<template>
    <div class="customer-purchases">
        <v-card>
            <v-card-title class="pt-2 pb-2">
                <TippTitle
                    position="bottom"
                    :tipp="about"
                    title="Purchases (Käufe)"
                    :loading="purchasesCeleraone.loading"
                    :reloadCb="getPurchasesCeleraone"
                />
            </v-card-title>
            <v-card-text class="pt-0">
                <KeineDaten v-if="purchases.length <= 0"></KeineDaten>
                <v-data-table
                    v-if="purchases.length > 0"
                    hide-default-footer
                    disable-pagination
                    :headers="headers"
                    :items="purchases"
                >
                    <template slot="item" slot-scope="props">
                        <tr :class="props.item.class">
                            <td>{{ props.item.product_id }}</td>
                            <td>{{ props.item.purchase_id }}</td>
                            <td>{{ props.item.ab | toDate }}</td>
                            <td>{{ props.item.bis | toDate }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import TippTitle from '@/components/TippTitle.vue';

export default {
    name: 'Purchases',
    components: {
        KeineDaten,
        TippTitle,
    },
    data() {
        return {
            about: 'Zeigt Informationen zu den Käufen des Kunden an. Die Produkt-ID entspricht der Identifikationsnummer des gekauften Produktes, die Purchases-ID dient der Identifizierung des Kaufprozesses. Aktive Käufe sind grün dargestellt.',
            headers: [{
                text: 'Produkt-ID',
                align: 'left',
                sortable: false,
                value: 'product_id',
            }, {
                text: 'Purchase-ID',
                align: 'left',
                value: 'purchase_id',
                sortable: false,
            }, {
                text: 'ab',
                value: 'ab',
                sortable: false,
            }, {
                text: 'bis',
                value: 'bis',
                sortable: false,
            }],
        };
    },
    computed: {
        ...mapGetters('customerDetail', ['purchases']),
        ...mapState('customerDetail', ['purchasesCeleraone']),
    },
    methods: mapActions('customerDetail', ['getPurchasesCeleraone']),
};

</script>
<style scoped lang="scss">
    .green-row {
        color: #4CAF50;
    }
    .grey-row {
        color: #9E9E9E;
    }
</style>
